import { BusinessDetails } from "lib/features/auth/types";
import api from "./api";

const businessServices = {
  // GET
  getBusinessDetail(businessId: number) {
    const endpoint = `/business/business/items?businessId=${businessId}`;
    return api.get(endpoint);
  },
  getUserBusiness(userId: number) {
    const endpoint = `/business/user/${userId}`;
    return api.get(endpoint);
  },



  // PUT
  updateUserBusiness({
    payload,
    businessId,
  }: {
    payload: Partial<BusinessDetails>;
    businessId: number;
  }) {
    const endpoint = `/business?businessId=${businessId}`;
    return api.put(endpoint, payload);
  },
};

export default businessServices;
